const gardeningService = {
  title: "Gardening",
  icon: "🌿",
  rateCardKey: "gardening",
  shortDescription:
    "Plant care, balcony gardening, trimming, soil support, and home garden maintenance.",
  longDescription:
    "Book gardening support for balcony gardens, basic maintenance, trimming, pot setup, watering support, and home landscape upkeep. Pricing depends on visit type, number of pots/plants, and equipment needs.",
  consultationNote:
    "Large terrace garden setup, landscape redesign, irrigation planning, or bulk plantation work should begin with inspection.",
  responsePromise:
    "Assignment depends on garden size, task type, and local gardener availability.",
  warrantyPolicy:
    "Gardening outcomes depend on plant condition, weather, user care after service, and material quality.",
  subServices: [
    {
      id: "gardening-basic-maintenance",
      title: "Basic Garden Maintenance",
      icon: "🪴",
      group: "Maintenance",
      description:
        "Basic upkeep including light pruning, cleaning dry leaves, and plant-area tidying.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "1-2 hrs",
      warranty: "Service completion only",
      unit: "visit",
    },
    {
      id: "gardening-plant-repotting",
      title: "Plant Repotting",
      icon: "🌱",
      group: "Plant Care",
      description:
        "Repot plants into new containers with soil handling and basic placement support.",
      basePrice: 149,
      priceType: "fixed",
      duration: "15-30 mins per pot",
      warranty: "Service completion only",
      unit: "pot",
    },
    {
      id: "gardening-trimming",
      title: "Hedge / Plant Trimming",
      icon: "✂️",
      group: "Maintenance",
      description:
        "Trim overgrown plants, hedge edges, or light decorative greens within household limits.",
      basePrice: 599,
      priceType: "starts_at",
      duration: "1-2 hrs",
      warranty: "Service completion only",
      unit: "visit",
    },
    {
      id: "gardening-new-setup",
      title: "Balcony Garden Setup Consultation",
      icon: "🏡",
      group: "Consultation",
      description:
        "Consultation for pot placement, plant planning, aesthetic layout, and starter setup ideas.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Consultation only",
      unit: "visit",
    },
  ],
};

export default gardeningService;